import React from "react";

const StoreModal = props => {
  const { data } = props;

  return (
    <div>
      <form>
        <div className="d-flex">
          {data.storeLogo && (
            <div className="form-group">
              <label className="fs-16 medium-text"> Image&nbsp;:&nbsp;</label>
              <div>
                <div id="item_icon">
                  <img
                    className="top-header-profile-class view-image"
                    src={data.storeLogo}
                    style={{
                      height: "150px",
                      width: "150px",
                      marginBottom: "15px"
                    }}
                    alt="loading..."
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">Store Name&nbsp;:&nbsp;</label>
          {data.storeName}
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">Store Code&nbsp;:&nbsp;</label>
          <code
            className="fs-14"
            style={{
              background: "#f0f0f0",
              padding: "4px 8px",
              borderRadius: "4px"
            }}
          >
            {data.storeCode || "Not generated"}
          </code>
          {data.storeCode && (
            <button
              type="button"
              className="ml-10 c-btn c-info fs-12"
              onClick={() => {
                navigator.clipboard.writeText(data.storeCode);
                alert("Store Code copied to clipboard!");
              }}
            >
              <i className="fas fa-copy" /> Copy
            </button>
          )}
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">
            Store Description&nbsp;:&nbsp;
          </label>
          {data?.storeDescription}
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">Active&nbsp;:&nbsp;</label>
          {data.active ? "Yes" : "No"}
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">
            Is Loyalty Partner&nbsp;:&nbsp;
          </label>
          {data.storeLoyaltyPartner ? "Yes" : "No"}
        </div>
        {data?.promotionalAdvertisementList?.map((val, index) => (
          <div className="mb-4 border rounded p-2">
            <label className="fs-16 medium-text">
              Advertisement {index + 1}
            </label>
            <div className="form-group mb-1 mt-2">
              <label className="fs-16 medium-text">Default&nbsp;:&nbsp;</label>
              {val.default ? "True" : "False"}
            </div>
            <div className="form-group mb-1">
              <label className="fs-16 medium-text">
                Product Name&nbsp;:&nbsp;
              </label>
              {val.promotionalProductName}
            </div>
            <div className="form-group mb-2">
              <label className="fs-16 medium-text ">
                Advertisement Image Link&nbsp;:&nbsp;
              </label>
              <div className="breakWord">{val.advertisementImageLink}</div>
            </div>
            <div className="d-flex">
              {val.advertisementImage && (
                <div className="form-group">
                  <label className="fs-16 medium-text">
                    Advertisement Image&nbsp;:&nbsp;
                  </label>
                  <div>
                    <div id="item_icon">
                      <img
                        className="top-header-profile-class view-image"
                        src={val.advertisementImage}
                        style={{
                          height: "150px",
                          width: "200px",
                          marginBottom: "15px"
                        }}
                        alt="loading..."
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </form>
    </div>
  );
};

export default StoreModal;
